(function () {
  if (window.FarmexDescuentos) return;

  const API_NEGOTIATED_URL = 'https://services.farmex.cl/product/getNegotiatedPrices/';
  const API_CUPONES_CAMPANIA_URL = 'https://services.farmex.cl/product/getCuponesCampania';

  const CAMPANIAS_LOGOS = {
    Fonasa: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/fonasa_defee691-b640-4e6d-9e4b-c524b0d5694c.png?v=1767964667',
    Metlife: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/metlife_logo.png?v=1771338125',
    'Receta Solidaria': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/receta-solidaria.svg?v=1771339448',
    'Seguros SURA': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/seguros-sura.png?v=1771343582',
    'Mujer Artemisa': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/mujer-artemisa_0f5683a2-fbdd-4ab2-be25-03ab196d21e2.png?v=1771342444',
    BanMedica: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/banmedica_6376cc71-7270-4b79-b685-b8323ea9013f.png?v=1771339711',
    VidaTres: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/vidatres.png?v=1771339837',
    Consorcio: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/consorcio_45518966-8488-44ff-8a95-35ef0961690c.png',
    Sermecoop: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/sermecoop_6ef62b5a-dcb8-4743-a4f8-3166eb012546.png?v=1771343988',
    'Chile Salud': 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/logo-chilesalud.png?v=1742564337',
    MiaHealth: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/Mia-Health_5b47e5e6-0300-4115-bc46-eaed0a53cf98.png?v=1743774110'
    //Pluxee: 'https://cdn.shopify.com/s/files/1/0024/6058/1940/files/pluxee_8ade09c4-c480-4646-a74f-ee5cf2c8ba75.png'
  };

  function fetchDescuentosCombinados(productId, sku, precioLista) {
    const legacyPromise = fetch(API_NEGOTIATED_URL + productId).then((r) => r.json());

    const cuponesPromise =
      sku && precioLista
        ? fetch(
            `${API_CUPONES_CAMPANIA_URL}?sku=${encodeURIComponent(sku)}&precio_lista=${precioLista}&id_producto=${productId}`
          )
            .then((r) => r.json())
            .catch(() => [])
        : Promise.resolve([]);

    return Promise.all([legacyPromise, cuponesPromise]).then(([legacy, cuponesPayload]) => {
      const legacyItems = Array.isArray(legacy) ? legacy : [];
      const cuponesItems = Array.isArray(cuponesPayload?.descuentos)
        ? cuponesPayload.descuentos
        : Array.isArray(cuponesPayload)
          ? cuponesPayload
          : [];

      const campaniasCupones = Array.isArray(cuponesPayload?.campanias) ? cuponesPayload.campanias : [];

      const legacyFiltrado = legacyItems.filter((item) => !campaniasCupones.includes(item?.campania));

      return [...legacyFiltrado, ...cuponesItems];
    });
  }

  function procesarDescuentosVisibles(myJson) {
    if (!Array.isArray(myJson) || myJson.length === 0) return [];

    const result = [];
    const metlifeAgregado = new Set();
    const recetaSolidaria = [];

    myJson.forEach((item) => {
      if (!item?.campania || !item?.precioNegociado) return;
      if (!CAMPANIAS_LOGOS[item.campania]) return;

      if (item.campania === 'Metlife') {
        if (metlifeAgregado.has('Metlife')) return;
        metlifeAgregado.add('Metlife');
      }

      if (item.campania === 'Receta Solidaria') {
        recetaSolidaria.push(Number(item.precioNegociado));
        return;
      }

      result.push({
        campania: item.campania,
        precioNegociado: Number(item.precioNegociado)
      });
    });

    if (recetaSolidaria.length > 0) {
      result.push({
        campania: 'Receta Solidaria',
        precioNegociado: Math.min(...recetaSolidaria)
      });
    }

    return result;
  }

  function obtenerMenorPrecioNegociado(productId, sku, precioLista, callback) {
    fetchDescuentosCombinados(productId, sku, precioLista)
      .then((items) => {
        const visibles = procesarDescuentosVisibles(items);

        if (!visibles.length) {
          callback(null);
          return;
        }

        const menor = visibles.reduce((a, b) =>
          b.precioNegociado < a.precioNegociado ? b : a
        );

        callback(menor);
      })
      .catch(() => callback(null));
  }

  function formatNumber(value) {
    return Number(value).toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP'
    });
  }

  function pintarItem(grid, campania, precio) {
    const logo = CAMPANIAS_LOGOS[campania];
    if (!logo) return;

    const div = document.createElement('div');
    div.className = 'logo-item-cp';
    div.innerHTML = `
      <img src="${logo}" alt="${campania}">
      <p>${formatNumber(precio)}</p>
    `;

    grid.appendChild(div);
  }

  function renderDescuentosGrid(contenedor, myJson) {
    if (!contenedor || !Array.isArray(myJson) || myJson.length === 0) return;

    contenedor.innerHTML = `
      <div class="logos-section-cp">
        <h2 id="ofertas">Descuentos</h2>
        <p>
          <span class="color-red">Importante:</span>
          Para obtener tu descuento, recuerda ingresar tu RUT durante el proceso de pago.
        </p>
        <div class="logos-grid-cp" id="logosGridCp"></div>
      </div>
    `;

    const grid = document.getElementById('logosGridCp');
    const visibles = procesarDescuentosVisibles(myJson);

    visibles.forEach((item) => {
      pintarItem(grid, item.campania, item.precioNegociado);
    });
  }

  function formatPrecioConvenio(precio) {
    return Number(precio).toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    });
  }

  function getVariantData(el) {
    const variant = window.PRODUCT_VARIANT || {};
    return {
      sku: el.dataset.sku || variant.sku || '',
      precioLista: Number(el.dataset.precioLista) || Number(variant.price) || 0
    };
  }

  function initPrecioConvenioUI() {
    const fichaElements = document.querySelectorAll('#MejorPrecioConvenio, .mejor-precio-convenio');
    const cardElements = document.querySelectorAll('.precio-convenio[data-product-id]');

    fichaElements.forEach((el) => {
      if (el.dataset.loaded === 'true') return;

      const productId = el.dataset.productId;
      const precioNormal = Number(el.dataset.precioNormal);
      const { sku, precioLista } = getVariantData(el);

      if (!productId || !precioNormal) return;

      el.dataset.loaded = 'true';

      obtenerMenorPrecioNegociado(productId, sku, precioLista, (menor) => {
        if (!menor) {
          el.style.display = 'none';
          return;
        }

        const precioNegociado = Number(menor.precioNegociado);
        if (precioNegociado >= precioNormal) return;

        const convenioEl = el.querySelector('.convenio');
        if (convenioEl) {
          convenioEl.textContent = formatPrecioConvenio(precioNegociado);
        }
      });
    });

    cardElements.forEach((el) => {
      if (el.dataset.loaded === 'true') return;

      const productId = el.dataset.productId;
      const precioNormal = Number(el.dataset.precioNormal);
      const { sku, precioLista } = getVariantData(el);

      if (!productId || !precioNormal) return;

      el.dataset.loaded = 'true';

      obtenerMenorPrecioNegociado(productId, sku, precioLista, (menor) => {
        if (!menor) return;

        const precioNegociado = Number(menor.precioNegociado);
        if (precioNegociado >= precioNormal) return;

        el.innerHTML = `
          <p class="precio-convenio-texto">
            Mejor precio convenio: ${formatPrecioConvenio(precioNegociado)}
          </p>
        `;
      });
    });
  }

  function bootPrecioConvenioUI() {
    initPrecioConvenioUI();

    if (!window.__farmexPrecioConvenioObserver) {
      window.__farmexPrecioConvenioObserver = new MutationObserver(initPrecioConvenioUI);
      window.__farmexPrecioConvenioObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  window.FarmexDescuentos = {
    CAMPANIAS_LOGOS,
    fetchDescuentosCombinados,
    procesarDescuentosVisibles,
    obtenerMenorPrecioNegociado,
    renderDescuentosGrid,
    formatNumber,
    initPrecioConvenioUI,
    bootPrecioConvenioUI
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPrecioConvenioUI);
  } else {
    bootPrecioConvenioUI();
  }
})();
